import { createContext, useContext } from 'react';

const RenderModeContext = createContext('spa');

export const useRenderMode = () => useContext(RenderModeContext);
export const RenderModeProvider = RenderModeContext.Provider;
export default RenderModeContext;
